import { render, staticRenderFns } from "./Etiqueta.vue?vue&type=template&id=1e56fd26&scoped=true&"
import script from "./Etiqueta.vue?vue&type=script&lang=js&"
export * from "./Etiqueta.vue?vue&type=script&lang=js&"
import style0 from "./Etiqueta.vue?vue&type=style&index=0&id=1e56fd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e56fd26",
  null
  
)

export default component.exports